import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import React, { useState, useEffect } from 'react'
import { PHARMA_ACTIVE_TYPE, PHARMA_SHIPPING_TYPE, NOTIFICATION_MESSAGE_TYPE } from '../../../constants'
import MESSAGES from '../../../constants/Messages'
import { sendEmailForAssistance } from '../../../utils/ExceptionHandlingUtil'
import { useTranslation } from 'react-i18next'
import { CustomPopup } from '../../../common/Popup/CustomPopup'

const DgValidationPopup = ({
    additionalInfoData,
    setAdditionalInfoData,
    displayDgValidationPopup,
    setDisplayDgValidationPopup,
    handleClear,
    selectedDestination,
    selectedOrigin,
    shippingDate,
    shippingItem,
    setIsLoading,
    setNotificationMessage,
    setNotificationType,
    additionalSccs,
    popupNotificationPopup,
    exceptionType,
    setExceptionType,
    spUnid,
    setUnid,
    setUnidName,
    unid,
    setUnidSelectedValidation
}) => {

    const { t, i18n } = useTranslation(['labels', 'errors'])

    const handleCancel = () => {
        setDisplayDgValidationPopup(false)
        setUnid('')
        setUnidName()
        setUnidSelectedValidation()

    }

    const handleConfirm = async () => {
        const attributes = [
            {
                key: 'origin',
                value: selectedOrigin ? selectedOrigin.code : null,
            },
            {
                key: 'destination',
                value: selectedDestination ? selectedDestination.code : null,
            },
            {
                key: 'shippingItem',
                value: shippingItem &&
                    shippingItem.description &&
                    shippingItem.product
                    ? `${shippingItem.description}-${shippingItem.product}`
                    : null,
            },
            {
                key: 'shippingDate',
                value: shippingDate ? moment(shippingDate).format('DD MMM YYYY') : null,
            },
            {
                key: 'sccs',
                value: getSccs(additionalSccs),
            },

            {
                key: "unid",
                value: spUnid ? spUnid : null
            },
            {
                key: "shippingProduct",
                value: shippingItem &&
                    shippingItem?.product
                    ? `${shippingItem.product}`
                    : null,
            }

        ]
        const replacements = {
            '%DESCRIPTION%': shippingItem ? shippingItem.description : '',
        }
        const response = await sendEmailForAssistance(
            'DG_SP',
            setIsLoading,
            attributes,
            replacements
        )
        setDisplayDgValidationPopup(false)
        if (response) {
            setNotificationMessage(t(MESSAGES.ASSISTANCE_MSG, { ns: 'errors' }))
            setNotificationType(NOTIFICATION_MESSAGE_TYPE.INFO)
        } else {
            setNotificationMessage(
                t(MESSAGES.MAIL_ASSISTANCE_FAILS, { ns: 'errors' })
            )
            setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR)
        }
        window.scrollTo(0, 0)
        handleClear()
    }

    const getSccs = (additionalSccs) => {
        if (additionalSccs && additionalSccs.length) {
            return additionalSccs.map((e) => e.scc).toString()
        } else {
            return null
        }
    }




    return (

        <CustomPopup
            isVisible={displayDgValidationPopup}
            headerComponent={{ mainHeader: popupNotificationPopup.header || t('BOOKING.ASSISTANCE_HEAD') }}
            body={<p style={{ fontSize: '16px' }}>
                {popupNotificationPopup.body}
            </p>}
            footerPriBtnLabel={t('COMMON.OK')}
            footerPriBtnClick={() => {
                if (popupNotificationPopup.header === '') {
                    handleConfirm()
                } else {
                    handleCancel()
                }
            }}
            footerSecBtnLabel={popupNotificationPopup.header === '' ? t('COMMON.CANCEL') : ''}
            footerSecBtnClick={handleCancel} 
            onClose={handleCancel}
        />


    )
}

export default DgValidationPopup
